import { Employee } from "@finway-group/shared/lib/models"
import { Input, Menu } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import UserImage from "~Components/UserImage"
import { KeySelector, useSearch } from "~Shared/hooks/search.hooks"

export interface EmployeeListProps {
    employees: Array<Employee>
    keySelector: KeySelector<Employee>
    onEmployeeSelect: (employee: Employee) => Promise<void>
}

export const EmployeeList = ({ employees, keySelector, onEmployeeSelect, ...antdProps }: EmployeeListProps) => {
    const { t } = useTranslation()
    const { searchTerm, searchResults, handleInputChange, handleInputClick } = useSearch(employees, keySelector)

    const handleClick = (domEvent: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, employee: Employee) => {
        domEvent.preventDefault()
        domEvent.stopPropagation()
        onEmployeeSelect(employee)
    }

    return (
        <Menu className="mx-10">
            <Menu.Item>
                <Input type="text" placeholder={t("action:inbox_invoice.search")} value={searchTerm} onChange={handleInputChange} onClick={handleInputClick} />
            </Menu.Item>

            {searchResults.map((employee) => (
                <Menu.Item
                    key={employee.id}
                    {...antdProps}
                    icon={<UserImage user={employee} />}
                    style={{ display: "flex", gap: "8px", alignItems: "center" }}
                    onClick={({ domEvent }) => handleClick(domEvent, employee)}
                >
                    <span className="text-text truncate leading-none w-120">{keySelector(employee)}</span>
                </Menu.Item>
            ))}
        </Menu>
    )
}
